import { useEffect } from "react";

interface MetaOptions {
  title: string;
  description?: string;
}

export default function useDocumentMeta({ title, description }: MetaOptions) {
  useEffect(() => {
    document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}